import * as React from 'react';

import { cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $remoteFacilities } from '../../_state/facilities.state';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

type SalesRootLayoutProps = {
  children: React.ReactNode;
  className?: string;
  moduleNavigation?: NavItem;
};

export const SalesRootLayout = ({
  children,
  className,
  moduleNavigation,
}: SalesRootLayoutProps) => {
  const { fetch: fetchFacilities } = useAtomValue($remoteFacilities);

  React.useEffect(() => {
    fetchFacilities({
      limit: 1000,
    });
  }, [fetchFacilities]);

  return (
    <ModuleLayout
      moduleNavigation={moduleNavigation}
      noContentPadding={true}
      className={cn('@SalesRootLayout', className)}
    >
      {children}
    </ModuleLayout>
  );
};
